import { render, staticRenderFns } from "./AvailableDiscountsBanner.vue?vue&type=template&id=2df4976b&scoped=true"
import script from "./AvailableDiscountsBanner.vue?vue&type=script&lang=ts"
export * from "./AvailableDiscountsBanner.vue?vue&type=script&lang=ts"
import style0 from "./AvailableDiscountsBanner.vue?vue&type=style&index=0&id=2df4976b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df4976b",
  null
  
)

export default component.exports